import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Switch, Route, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveContactUs } from "../../services/apiOtherlink";
import Validation from "../../commonComponents/Validation";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import "../../assets/css/style.css"
const ContactUs = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");

   useEffect(() => {
     setEmail(userData.email);
     setFullName(`${userData.firstName + " " + userData.lastName}`)
   },[])

  const saveContact = async () => {
    if (fullName !== "" && email !== "" && comment !== "") {
      setError(false)
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const result = pattern.test(email);
      if (result === false) {
        setEmailError(true)
      }
      else {
        setEmailError(false);
        const formData = {
          fullname: fullName,
          email: email,
          comment: comment
        }
        let contactSave = await saveContactUs(formData);

        if (contactSave.status) {
          setComment("")
            SetSucess(true);
            SetResponseMessage("The admin will review your suggestions and take the necessary steps");
        }
      }

    }
    else {
      setError(true);

    }
  }
  const cancelContact = async () => {
    setComment("");
  }
  return (
    <div>
      <div className="hd-breadcums">
        <h3 className="main-heading">ContactUs</h3>
      </div>

      <div className="edit-container contact-us">
        <div className="edit profile-wrapper">
          <div className="edit-field">
            <label className="edit-profile-label">Full name</label>
            <div className="edit-field-group">
              <div className="form-group">
                <input type="text"  className="form-control" readOnly
                placeholder="Enter your Full name" style={{color:"black"}}
                  onChange={(e) => { setFullName(e.target.value) }} value={fullName} />
                {fullName === "" && error ? (
                  <Validation message={'Please enter your full name'} />
                ) : null}
              </div>
            </div>
          </div>

          <div className="edit-field">
            <label className="edit-profile-label">Email Id</label>
            <div className="edit-field-group">
              <div className="form-group">
                <input type="text" placeholder="Enter your Email" className="form-control " readOnly
                  onChange={(e) => { setEmail(e.target.value); setEmailError(false) }} value={email} />
                {email === "" && error ? (
                  <Validation message={'Please enter your email'} />
                ) : null}
                {email !== "" && emailError ? (
                  <Validation message={'Please enter valid email'} />
                ) : null}
              </div>
            </div>
          </div>

          <div className="edit-field">
            <label className="edit-profile-label">Suggestion</label>
            <div className="edit-field-group">
              <div className="form-group">
                <textarea className="form-control " placeholder="Please enter your Suggestions"
                  onChange={(e) => { setComment(e.target.value) }} value={comment} />
                {comment === "" && error ? (
                  <Validation message={'Please enter your suggestions'} />
                ) : null}
              </div>
            </div>
          </div>

          <div className="main-action-buttons">
            <button className="act-buttons bg-light text-dark" onClick={() => cancelContact()}>Cancel</button>
            <button className="act-buttons" onClick={() => saveContact()}>Submit</button>
          </div>
        </div>
      </div>
{isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
    </div>

  );
};
export default ContactUs;